<template>
  <div>
    <div class="weui-cells__title" v-if="title" :style="{color:titleColor}" v-html="title"></div>
    <div class="weui-cells" :class="{'weui-cells_form':isForm, 'yxy-no-group-title':!title}" :style="{marginTop: gutter}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    titleColor: String,
    gutter: String,
    isForm: Boolean
  }
}
</script>
